// extracted by mini-css-extract-plugin
module.exports = {"scrollContainer":"Matches_scrollContainer__3XKCU","error":"Matches_error__3BjOB"};